import { showLoadingToast, toast } from "@/components/ui/sonner";
import { uploadFileViaApi } from "./upload.api";
import type { UploadedAsset, UploadContextKey } from "./types";

export type UploadFileOptions = {
  key: UploadContextKey;
  maxBytesPerFile?: number;
  /** Default true. Set false when an outer wrapper already shows upload progress. */
  showLoadingToast?: boolean;
};

/**
 * Send file to the API; the server writes to S3 and returns the CDN URL.
 */
export async function uploadFile(
  file: File,
  options: UploadFileOptions,
): Promise<UploadedAsset> {
  const showToast = options.showLoadingToast !== false;
  const toastId = showToast ? showLoadingToast("Uploading file…") : null;
  try {
    const asset = await uploadFileViaApi(options.key, file, {
      maxBytesPerFile: options.maxBytesPerFile,
    });
    if (toastId != null) toast.dismiss(toastId);
    return asset;
  } catch (error) {
    if (toastId != null) toast.dismiss(toastId);
    throw error;
  }
}
